import { type CSSObject } from '@emotion/react';
import { type Theme, useTheme } from '../../../theme';

export const useFilterStyles = ({
  isOpen,
}: {
  isOpen: boolean;
}): {
  filter: CSSObject;
  label: CSSObject;
  chevron: CSSObject;
} => {
  const theme = useTheme();

  return {
    filter: {
      display: 'inline-flex',
      height: 32,
      padding: theme.spacing(1, '6px', 1, 2),
      alignItems: 'center',
      gap: theme.spacing(1),
      paddingRight: '6px',
      border: 'none',
      borderRadius: theme.shape.radius4,
      fontWeight: theme.typography.fontWeightRegular,
      fontFamily: theme.typography.fontFamily,

      '&:focus': {
        outline: `2.5px solid ${theme.button.focused.default}`,
      },
    },
    label: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      color: theme.text.generic.primary,
    },
    chevron: {
      transform: isOpen ? 'rotate(180deg);' : undefined,
      transition: `transform ${theme.transitions.duration.short}ms`,
    },
  };
};

export const getButtonVariant = (
  theme: Theme,
): {
  base: CSSObject;
  active: CSSObject;
  disabled: CSSObject;
} => ({
  base: {
    cursor: 'pointer',
    color: theme.text.generic.primary,
    backgroundColor: theme.filter.default,
    '&:hover': {
      backgroundColor: theme.filter.hover,
    },
    '& > svg': {
      color: theme.icon.primary,
    },
  },
  active: {
    color: theme.text.interactive.active,
    backgroundColor: theme.filter.active,
    '&:hover': {
      backgroundColor: theme.filter.active,
    },
    '& > svg': {
      color: theme.text.interactive.active,
    },
  },
  disabled: {
    cursor: 'unset',
    color: theme.text.generic.tertiary,
    backgroundColor: theme.filter.disabled,
    '&:hover': {
      backgroundColor: theme.filter.disabled,
    },
    '& > svg': {
      color: theme.icon.tertiary,
    },
  },
});
